module.exports = __webpack_public_path__ + "static/media/EnergySmartIcon.66bdf88d.svg";